/**
 * 可以通过用户国籍获取国旗url，建议需要国旗的话使用getFlagUrl函数
 */
export const FLAG_NAME = {
  source: [
    {
      code: "HK",
      en: "Hong Kong (China)",
      cn: "香港（中国）"
    },
    {
      code: "TW",
      en: "Taiwan (China)",
      cn: "台湾（中国）"
    },
    {
      code: "MO",
      en: "Macau (China)",
      cn: "澳门（中国）"
    },
    {
      code: "US",
      en: "USA",
      cn: "美国"
    },
    {
      code: "AR",
      en: "Argentina",
      cn: "阿根廷"
    },
    {
      code: "AE",
      en: "UAE",
      cn: "阿联酋"
    },
    {
      code: "AF",
      en: "Afghanistan",
      cn: "阿富汗"
    },
    {
      code: "RU",
      en: "Russia",
      cn: "俄罗斯"
    },
    {
      code: "KH",
      en: "Cambodia",
      cn: "柬埔寨"
    },
    {
      code: "MM",
      en: "Myanmar(Burma)",
      cn: "缅甸"
    },
    {
      code: "GN",
      en: "Guinea",
      cn: "几内亚"
    },
    {
      code: "LC",
      en: "Saint Lucia",
      cn: "圣卢西亚"
    },
    {
      code: "KE",
      en: "Kenya",
      cn: "肯尼亚"
    },
    {
      code: "CV",
      en: "Cape Verde",
      cn: "佛得角"
    },
    {
      code: "BY",
      en: "Belarus",
      cn: "白俄罗斯"
    },
    {
      code: "MV",
      en: "Maldives",
      cn: "马尔代夫"
    },
    {
      code: "IS",
      en: "Iceland",
      cn: "冰岛"
    },
    {
      code: "BH",
      en: "Bahrain",
      cn: "巴林"
    },
    {
      code: "DK",
      en: "Denmark",
      cn: "丹麦"
    },
    {
      code: "ET",
      en: "Ethiopia",
      cn: "埃塞俄比亚"
    },
    {
      code: "NL",
      en: "Netherlands",
      cn: "荷兰"
    },
    {
      code: "RW",
      en: "Rwanda",
      cn: "卢旺达"
    },
    {
      code: "MN",
      en: "Mongolia",
      cn: "蒙古国"
    },
    {
      code: "UY",
      en: "Uruguay",
      cn: "乌拉圭"
    },
    {
      code: "LK",
      en: "Sri Lanka",
      cn: "斯里兰卡"
    },
    {
      code: "TG",
      en: "Togo",
      cn: "多哥"
    },
    {
      code: "CU",
      en: "Cuba",
      cn: "古巴"
    },
    {
      code: "CL",
      en: "Chile",
      cn: "智利"
    },
    {
      code: "GR",
      en: "Greece",
      cn: "希腊"
    },
    {
      code: "CI",
      en: "Cote d'Ivoire",
      cn: "科特迪瓦"
    },
    {
      code: "BO",
      en: "Bolivia",
      cn: "玻利维亚"
    },
    {
      code: "TH",
      en: "Thailand",
      cn: "泰国"
    },
    {
      code: "ID",
      en: "Indonesia",
      cn: "印尼"
    },
    {
      code: "BG",
      en: "Bulgaria",
      cn: "保加利亚"
    },
    {
      code: "ER",
      en: "Eritrea",
      cn: "厄立特里亚"
    },
    {
      code: "KG",
      en: "Kyrgyzstan",
      cn: "吉尔吉斯斯坦"
    },
    {
      code: "JP",
      en: "Japan",
      cn: "日本"
    },
    {
      code: "PT",
      en: "Portugal",
      cn: "葡萄牙"
    },
    {
      code: "DJ",
      en: "Djibouti",
      cn: "吉布提"
    },
    {
      code: "CO",
      en: "Colombia",
      cn: "哥伦比亚"
    },
    {
      code: "IN",
      en: "India",
      cn: "印度"
    },
    {
      code: "ES",
      en: "Spain",
      cn: "西班牙"
    },
    {
      code: "SZ",
      en: "Swaziland",
      cn: "斯威士兰"
    },
    {
      code: "BD",
      en: "Bangladesh",
      cn: "孟加拉"
    },
    {
      code: "AO",
      en: "Angola",
      cn: "安哥拉"
    },
    {
      code: "LU",
      en: "Luxembourg",
      cn: "卢森堡"
    },
    {
      code: "JO",
      en: "Jordan",
      cn: "约旦"
    },
    {
      code: "CN",
      en: "China",
      cn: "中国"
    },
    {
      code: "MX",
      en: "Mexico",
      cn: "墨西哥"
    },
    {
      code: "KW",
      en: "Kuwait",
      cn: "科威特"
    },
    {
      code: "TM",
      en: "Turkmenistan",
      cn: "土库曼斯坦"
    },
    {
      code: "IT",
      en: "Italy",
      cn: "意大利"
    },
    {
      code: "OM",
      en: "Oman",
      cn: "阿曼"
    },
    {
      code: "BR",
      en: "Brazil",
      cn: "巴西"
    },
    {
      code: "ML",
      en: "Mali",
      cn: "马里"
    },
    {
      code: "ZW",
      en: "Zimbabwe",
      cn: "津巴布韦"
    },
    {
      code: "NI",
      en: "Nicaragua",
      cn: "尼加拉瓜"
    },
    {
      code: "PY",
      en: "Paraguay",
      cn: "巴拉圭"
    },
    {
      code: "NZ",
      en: "New Zealand",
      cn: "新西兰"
    },
    {
      code: "FM",
      en: "Micronesia",
      cn: "密克罗尼西亚"
    },
    {
      code: "GY",
      en: "Guyana",
      cn: "圭亚那"
    },
    {
      code: "PK",
      en: "Pakistan",
      cn: "巴基斯坦"
    },
    {
      code: "BS",
      en: "Bahamas",
      cn: "巴哈马"
    },
    {
      code: "SY",
      en: "Syria",
      cn: "叙利亚"
    },
    {
      code: "VN",
      en: "Viet Nam",
      cn: "越南"
    },
    {
      code: "TD",
      en: "Chad",
      cn: "乍得"
    },
    {
      code: "IQ",
      en: "Iraq",
      cn: "伊拉克"
    },
    {
      code: "AU",
      en: "Australia",
      cn: "澳大利亚"
    },
    {
      code: "JM",
      en: "Jamaica",
      cn: "牙买加"
    },
    {
      code: "IE",
      en: "Ireland",
      cn: "爱尔兰"
    },
    {
      code: "LT",
      en: "Lithuania",
      cn: "立陶宛"
    },
    {
      code: "RO",
      en: "Romania",
      cn: "罗马尼亚"
    },
    {
      code: "DO",
      en: "Dominican Republic",
      cn: "多米尼加"
    },
    {
      code: "VE",
      en: "Venezuela",
      cn: "委内瑞拉"
    },
    {
      code: "DM",
      en: "Dominica",
      cn: "多米尼克"
    },
    {
      code: "PS",
      en: "Palestine",
      cn: "巴勒斯坦"
    },
    {
      code: "IR",
      en: "Iran",
      cn: "伊朗"
    },
    {
      code: "PH",
      en: "Philippines",
      cn: "菲律宾"
    },
    {
      code: "SB",
      en: "Solomon Islands",
      cn: "所罗门群岛"
    },
    {
      code: "CR",
      en: "Costa Rica",
      cn: "哥斯达黎加"
    },
    {
      code: "MY",
      en: "Malaysia",
      cn: "马来西亚"
    },
    {
      code: "MG",
      en: "Madagascar",
      cn: "马达加斯加"
    },
    {
      code: "BT",
      en: "Bhutan",
      cn: "不丹"
    },
    {
      code: "AL",
      en: "Albania",
      cn: "阿尔巴尼亚"
    },
    {
      code: "GB",
      en: "UK",
      cn: "英国"
    },
    {
      code: "UK", // GB、UK 都是是英国国籍 nationality 的返回码
      en: "UK",
      cn: "英国"
    },
    {
      code: "HU",
      en: "Hungary",
      cn: "匈牙利"
    },
    {
      code: "TJ",
      en: "Tajikistan",
      cn: "塔吉克斯坦"
    },
    {
      code: "DZ",
      en: "Algeria",
      cn: "阿尔及利亚"
    },
    {
      code: "AM",
      en: "Armenia",
      cn: "亚美尼亚"
    },
    {
      code: "PR",
      en: "Puerto Rico (USA)",
      cn: "波多黎各"
    },
    {
      code: "BB",
      en: "Barbados",
      cn: "巴巴多斯"
    },
    {
      code: "NG",
      en: "Nigeria",
      cn: "尼日利亚"
    },
    {
      code: "KZ",
      en: "Kazakhstan",
      cn: "哈萨克斯坦"
    },
    {
      code: "TT",
      en: "Trinidad and Tobago",
      cn: "特立尼达和多巴哥"
    },
    {
      code: "TZ",
      en: "Tanzania",
      cn: "坦桑尼亚"
    },
    {
      code: "LR",
      en: "Liberia",
      cn: "利比里亚"
    },
    {
      code: "FJ",
      en: "Fiji",
      cn: "斐济群岛"
    },
    {
      code: "CM",
      en: "Cameroon",
      cn: "喀麦隆"
    },
    {
      code: "TN",
      en: "Tunisia",
      cn: "突尼斯"
    },
    {
      code: "IL",
      en: "Israel",
      cn: "以色列"
    },
    {
      code: "LV",
      en: "Latvia",
      cn: "拉脱维亚"
    },
    {
      code: "CA",
      en: "Canada",
      cn: "加拿大"
    },
    {
      code: "SA",
      en: "Saudi Arabia",
      cn: "沙特阿拉伯"
    },
    {
      code: "PE",
      en: "Peru",
      cn: "秘鲁"
    },
    {
      code: "NP",
      en: "Nepal",
      cn: "尼泊尔"
    },
    {
      code: "BJ",
      en: "Benin",
      cn: "贝宁"
    },
    {
      code: "UA",
      en: "Ukraine",
      cn: "乌克兰"
    },
    {
      code: "HR",
      en: "Croatia",
      cn: "克罗地亚"
    },
    {
      code: "TR",
      en: "Turkey",
      cn: "土耳其"
    },
    {
      code: "SG",
      en: "Singapore",
      cn: "新加坡"
    },
    {
      code: "YE",
      en: "Yemen",
      cn: "也门"
    },
    {
      code: "TL",
      en: "Timor-Leste",
      cn: "东帝汶"
    },
    {
      code: "AT",
      en: "Austria",
      cn: "奥地利"
    },
    {
      code: "GT",
      en: "Guatemala",
      cn: "危地马拉"
    },
    {
      code: "BE",
      en: "Belgium",
      cn: "比利时"
    },
    {
      code: "GE",
      en: "Georgia",
      cn: "格鲁吉亚"
    },
    {
      code: "MU",
      en: "Mauritius",
      cn: "毛里求斯"
    },
    {
      code: "LB",
      en: "Lebanon",
      cn: "黎巴嫩"
    },
    {
      code: "CH",
      en: "Switzerland",
      cn: "瑞士"
    },
    {
      code: "SO",
      en: "Somalia",
      cn: "索马里"
    },
    {
      code: "CY",
      en: "Cyprus",
      cn: "塞浦路斯"
    },
    {
      code: "QA",
      en: "Qatar",
      cn: "卡塔尔"
    },
    {
      code: "DE",
      en: "Germany",
      cn: "德国"
    },
    {
      code: "MA",
      en: "Morocco",
      cn: "摩洛哥"
    },
    {
      code: "PW",
      en: "Palau",
      cn: "帕劳"
    },
    {
      code: "SV",
      en: "El Salvador",
      cn: "萨尔瓦多"
    },
    {
      code: "CZ",
      en: "Czech Republic",
      cn: "捷克"
    },
    {
      code: "GA",
      en: "Gabon",
      cn: "加蓬"
    },
    {
      code: "HT",
      en: "Haiti",
      cn: "海地"
    },
    {
      code: "UG",
      en: "Uganda",
      cn: "乌干达"
    },
    {
      code: "NO",
      en: "Norway",
      cn: "挪威"
    },
    {
      code: "LY",
      en: "Libya",
      cn: "利比亚"
    },
    {
      code: "FR",
      en: "France",
      cn: "法国"
    },
    {
      code: "RS",
      en: "Serbia",
      cn: "塞尔维亚"
    },
    {
      code: "KR",
      en: "Korea",
      cn: "韩国"
    },
    {
      code: "SE",
      en: "Sweden",
      cn: "瑞典"
    },
    {
      code: "HN",
      en: "Honduras",
      cn: "洪都拉斯"
    },
    {
      code: "EE",
      en: "Estonia",
      cn: "爱沙尼亚"
    },
    {
      code: "EC",
      en: "Ecuador",
      cn: "厄瓜多尔"
    },
    {
      code: "GH",
      en: "Ghana",
      cn: "加纳"
    },
    {
      code: "UZ",
      en: "Uzbekistan",
      cn: "乌兹别克斯坦"
    },
    {
      code: "FI",
      en: "Finland",
      cn: "芬兰"
    },
    {
      code: "MR",
      en: "Mauritania",
      cn: "毛里塔尼亚"
    },
    {
      code: "SD",
      en: "Sudan",
      cn: "苏丹"
    },
    {
      code: "SN",
      en: "Senegal",
      cn: "塞内加尔"
    },
    {
      code: "ZA",
      en: "South Africa",
      cn: "南非"
    },
    {
      code: "AZ",
      en: "Azerbaijan",
      cn: "阿塞拜疆"
    },
    {
      code: "EG",
      en: "Egypt",
      cn: "埃及"
    },
    {
      code: "PA",
      en: "Panama",
      cn: "巴拿马"
    },
    {
      code: "PL",
      en: "Poland",
      cn: "波兰"
    },
    {
      code: "ZM",
      en: "Zambia",
      cn: "赞比亚"
    },

    {
      code: "SI",
      en: "Slovenia",
      cn: "斯洛文尼亚"
    },
    {
      code: "LA",
      en: "Laos",
      cn: "老挝"
    },
    {
      code: "AD",
      en: "Andorra",
      cn: "安道尔共和国"
    },
    {
      code: "AG",
      en: "Antigua and Barbuda",
      cn: "安提瓜和巴布达"
    },
    {
      code: "AW",
      en: "Aruba",
      cn: "阿鲁巴"
    },
    {
      code: "BZ",
      en: "Belize",
      cn: "伯利兹"
    },
    {
      code: "BA",
      en: "Bosnia",
      cn: "波斯尼亚和黑塞哥维那"
    },
    {
      code: "BW",
      en: "Botswana",
      cn: "博茨瓦纳共和国"
    },
    {
      code: "BN",
      en: "Brunei",
      cn: "文莱"
    },
    {
      code: "BI",
      en: "Burundi",
      cn: "布隆迪"
    },
    {
      code: "CF",
      en: "Central African Republic",
      cn: "中非共和国"
    },
    {
      code: "KM",
      en: "Comoros",
      cn: "科摩罗"
    },
    {
      code: "CD",
      en: "Democratic Republic of the Congo",
      cn: "刚果民主共和国"
    },
    {
      code: "CG",
      en: "Republic Of The Congo",
      cn: "刚果共和国"
    },
    {
      code: "CK",
      en: "Cook Islands",
      cn: "库克群岛"
    },
    {
      code: "CW",
      en: "Curacao",
      cn: "荷兰王国"
    },
    {
      code: "TL",
      en: "East Timor",
      cn: "东帝汶"
    },
    {
      code: "GQ",
      en: "Equatorial Guinea",
      cn: "赤道几内亚"
    },
    {
      code: "FO",
      en: "Faroe Islands",
      cn: "丹麦"
    },
    {
      code: "GL",
      en: "Greenland",
      cn: "丹麦"
    },
    {
      code: "GM",
      en: "Gambia",
      cn: "冈比亚共和国"
    },
    {
      code: "GD",
      en: "Grenada",
      cn: "格林纳达"
    },
    {
      code: "GU",
      en: "Guam",
      cn: "古阿姆"
    },
    {
      code: "KI",
      en: "Kiribati",
      cn: "基里巴斯"
    },
    {
      code: "LS",
      en: "Lesotho",
      cn: "莱索托王国"
    },
    {
      code: "LI",
      en: "Liechtenstein",
      cn: "列支敦士登公国"
    },
    {
      code: "MW",
      en: "Malawi",
      cn: "马拉维共和国"
    },
    {
      code: "MT",
      en: "Malta",
      cn: "马耳他共和国"
    },
    {
      code: "MH",
      en: "Marshall Islands",
      cn: "马绍尔群岛共和国"
    },
    {
      code: "MD",
      en: "Moldova",
      cn: "摩尔多瓦共和国"
    },
    {
      code: "MC",
      en: "Monaco",
      cn: "摩纳哥公国"
    },
    {
      code: "ME",
      en: "Montenegro",
      cn: "摩纳哥公国"
    },
    {
      code: "MZ",
      en: "Mozambique",
      cn: "莫桑比克共和国"
    },
    {
      code: "NA",
      en: "Namibia",
      cn: "纳米比亚共和国"
    },
    {
      code: "NR",
      en: "Nauru",
      cn: "瑙鲁共和国"
    },
    {
      code: "NE",
      en: "Niger",
      cn: "尼日尔共和国"
    },
    {
      code: "MK",
      en: "North Macedonia",
      cn: "北马其顿共和国"
    },
    {
      code: "PG",
      en: "Papua New Guinea",
      cn: "巴布亚新几内亚独立国"
    },
    {
      code: "KN",
      en: "Saint Kitts and Nevis",
      cn: "圣基茨和尼维斯联邦"
    },
    {
      code: "VC",
      en: "Saint Vincent and the Grenadines",
      cn: "圣文森特和格林纳丁斯"
    },
    {
      code: "WS",
      en: "Samoa",
      cn: "萨摩亚独立国"
    },
    {
      code: "SM",
      en: "San Marino",
      cn: "圣马力诺共和国"
    },
    {
      code: "ST",
      en: "Sao Tome And Principe",
      cn: "圣多美和普林西比民主共和国"
    },
    {
      code: "SC",
      en: "Seychelles",
      cn: "塞舌尔共和国"
    },
    {
      code: "SL",
      en: "Sierra Leone",
      cn: "塞拉利昂共和国"
    },
    {
      code: "SK",
      en: "Slovakia",
      cn: "斯洛伐克共和国"
    },
    {
      code: "SS",
      en: "South Sudan",
      cn: "南苏丹共和国"
    },
    {
      code: "SR",
      en: "Suriname",
      cn: "苏里南共和国"
    },
    {
      code: "TO",
      en: "Tonga",
      cn: "汤加王国"
    },
    {
      code: "VU",
      en: "Vanuatu",
      cn: "瓦努阿图共和国"
    },
    {
      code: "NU",
      en: "Niue",
      cn: "纽埃"
    }
  ]
};
